<script setup lang="ts">

import Dashboard from '@presentation/Icons/Dashboard.vue';

</script>

<template>

    <Page>

        <ImageAndText 
            src="/WhatIsCarbucks/dashboard.png"
            image-class="max-w-[600px] drop-shadow-xl"
            animation="slide-up"
            floor-shadow>

            <Animated :delay="500" :duration="500" animation="slide-left">
                <Dashboard />
            </Animated>

            <h2 class="my-4">Carbucks Dashboard</h2>
            <ul class="mt-3 list-disc list-inside font-normal text-white/80">
                <li>Live view of your Car Parc</li>
                <li>Service due</li>
                <li>Rego, Extended Warranty &amp; MVI expiry</li>
                <li>Recalls</li>
                <li>Program metrics and performance reports</li>
                <li>SMS &amp; push notifications</li>
            </ul>

        </ImageAndText>

    </Page>

</template>